// react
import { useEffect, useState } from "react";

// kendo
import kendo from "@progress/kendo-ui";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Button } from "@progress/kendo-react-buttons";
import { RadioButton } from "@progress/kendo-react-inputs";
import { filterBy } from "@progress/kendo-data-query";
import { isTransformerResult } from "@progress/kendo-data-query/dist/npm/transducers";

// css
import styles from './elderLog.module.css';

// service
import DatePickerKo from "../../com/dateInputs/datePickerKo";
import { getGridData, getUserListData } from "../../../service/log/elderLogService";
import { getUser, isAdmin, isDeveloper } from '../../../service/authService';
import { getRgns, getDongs } from './../../../service/areaService';
import { getUsers } from '../../../service/monitor/allStatusService';
import { updateDevice } from "../../../service/device/deviceService";


const ElderLogSearch = ({ conn, search, getDataSourceEvt, page, setPage, setSearch, dongList, locationState, elderInfo }) => {
  
  // // 양방향 테스트
  // const testList = ['리셋', '응급신호(A타입)', '응급신호(B타입)']
  // const [data, setData] = useState({
  //   cid: elderInfo.cid,
  //   cmdType: null,
  //   emergencyType: null,
  //   createDate: new Date(),
  //   cmdStatus: null,
  // })

  // const changeList = (e) => {
  //   if (e.value === '리셋') {
  //     setData((data) => {
  //       const item = { ...data };
  //       item.cmdType = 4;
  //       item.cmdStatus = 1;
  //       return item;
  //     })
  //   } else if (e.value === '응급신호(A타입)') {
  //     setData((data) => {
  //       const item = { ...data };
  //       item.cmdType = 2;
  //       item.emergencyType = 1;
  //       item.cmdStatus = 1;
  //       return item;
  //     })
  //   } else if (e.value === '응급신호(B타입)') {
  //     setData((data) => {
  //       const item = { ...data };
  //       item.cmdType = 2;
  //       item.emergencyType = 2;
  //       item.cmdStatus = 1;
  //       return item;
  //     })
  //   } else {
  //     setData((data) => {
  //       const item = { ...data };
  //       item.cmdType = null;
  //       item.emergencyType = null;
  //       item.cmdStatus = null;
  //       return item;
  //     })
  //   }
  // }

  // const changeStatus = (e) => {
  //   if(data.cmdType === null) {
  //     alert("디바이스 제어 명령을 선택해주세요.");
  //   } else {
  //     setData((data) => {
  //       const item = { ...data };
  //       item.cid = elderInfo.cid;
  //       updateDevice(conn, item);
  //       return item;
  //     })
  //   }
  // }

  const userInfo = getUser();
  const [loading, setLoading] = useState(false);

  // 날짜 Default 정의
  const today = new Date();

  // 날짜 MAX MIN
  const [startMax, setStartMax] = useState(today);
  const [endMin, setEndMin] = useState(today);
  // 체크 박스
  const [selectedValue, setSelectedValue] = useState("HH");

  // 유저 정보 리스트 데이터 소스
  const [userList, setUserList] = useState({
    all: [],
    filtered: [],
  });
  // 유저 드롭다운 박스
  const [user, setUser] = useState({ userTerm: "대상자 선택", userId: "" });
  const [dong, setDong] = useState({ dongTermSimple: "지역 검색", dongCode: "" });

  // 라디오 버튼 이벤트
  const radioChange = e => {
    search.radio = e.value;
    setSelectedValue(e.value);
  };

  const defualtValRgn = { rgnTermSimple: "시/군/구", rgnCode: "" };
  const defualtValDong = { dongTermSimple: "읍/면/동", dongCode: "" };
  const defaultValUser = { userTerm: "대상자 선택", userId: "" };

  const [dataState, setDataState] = useState({
    skip: 0,
    take: 24,
    // rgnCode: getUser().rgnCode,
    // dongCode: isManager() ? getUser().dongCode : '',
    meainStatCode: '',
    bizType: '',
    dangerElderYn: '',
    isNotPlan: '',
    // 드롭다운 시군구 표출 값
    rgnCode: userInfo.rgnCode,
    rgnTermSimple: null,
    rgns : { rgnTermSimple: "시/군/구", rgnCode: "" },
    // 드롭다운 읍면동 표출 값
    dongCode: userInfo.dongCode,
    dongTermSimple: null,
    dongs : { dongTermSimple: "읍/면/동", dongCode: "" },
    // 드롭다운 유저 표출 값
    userId: '',
    userTerm: '',
    users : { userTerm: "대상자 선택", userId: "" },
  });

  const [dataSource, setDataSource] = useState({
    results: [],
    total: 0,
    rgnList: [], 
    dongList: [],
    userList: [],
  });

  // 초기 데이터 가져오기
  const getDataList = () => {
    setLoading(true);
    // 시군구
    getRgns(conn)
    .then(response => {
      setSearch(search => {
        const item = { ...search };
        item.rgns = response.find(item => item.rgnCode === userInfo.rgnCode);
        return item;
      })
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.rgnList = response
        return item;
      })
      setLoading(false);
    })
    .catch(error => {
      console.log("getRgns error = ", error);
    });
    // 읍면동
    getDongs(conn, userInfo.rgnCode)
    .then(response => {
      setSearch(search => {
        const item = { ...search };
        item.dongs = response.find(item => item.dongCode === userInfo.dongCode);
        return item;
      })
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.dongList = response;
        return item;
      })
      setLoading(false);
    })
    .catch(error => {
      console.log("getDongs error = ", error);
    });
    // 대상자
    getUsers(conn, search)
    .then(response => {
      setDataSource(dataSource => {
        const item = { ...dataSource };
        // item.userList = response;
        item.userList = response.filter(item => item.meainStatCode !== "20005");
        return item;
      })
      setData(response.slice());
    })
    .catch(error => {
      console.log("getUserList error = ", error);
    })
  }

  // 시군구, 읍면동, 대상자 드롭다운 체인지 이벤트
  const changeDropEvent = e => {
    if (e.target.name === "rgn") {
      setSearch(search => {
        const item = { ...search };
        // 드롭다운 검색조건 변경
        item.rgnCode = e.target.value.rgnCode;
        item.rgns = e.target.value;
        // 하위 데이터 초기화
        item.dongs = { dongTermSimple: "읍/면/동", dongCode: "" };
        item.dongCode = "";
        item.users = { userTerm: "대상자 선택", userId: "" };;
        item.userId = "";
        item.userTerm = "";
        // 대상자 데이터 조회
        getUsers(conn, item)
        .then(response => {
          setDataSource(dataSource => {
            const item = { ...dataSource };
            // item.userList = response;
            item.userList = response.filter(item => item.meainStatCode !== "20005");
            return item;
          })
          setData(response.slice());
        })
        .catch(error => {
          console.log("getUserList error = ", error);
        })
        return item;
      })
      // 읍면동 데이터 조회
      getDongs(conn, e.value.rgnCode)
      .then(result => {
        setDataSource(dataSource => {
          const item = { ...dataSource };
          item.dongList = result;
          return item;
        })
      })
      .catch(error => {
        console.log("getDongs error = ", error);
      });

    } else if (e.target.name === "dong") {
      setSearch(search => {
        const item = { ...search };
        // 드롭다운 검색조건 변경
        item.dongCode = e.target.value.dongCode;
        item.dongs = e.target.value;
        // 하위 데이터 초기화
        item.users = { userTerm: "대상자 선택", userId: "" };;
        item.userId = "";
        item.userTerm = "";
        // 대상자 데이터 조회
        getUsers(conn, item)
        .then(response => {
          setDataSource(dataSource => {
            const item = { ...dataSource };
            // item.userList = response;
            item.userList = response.filter(item => item.meainStatCode !== "20005");
            return item;
          })
          setData(response.slice());
        })
        .catch(error => {
          console.log("getUserList error = ", error);
        })
        return item;
      })
    } else if (e.target.name === 'user') {
      // 드롭다운 검색조건 변경
      if(e.target.value.userTerm === "대상자 선택") {
        setSearch(search => {
          const item = { ...search };
          item.userId = e.target.value.userId;
          item.userTerm = "";
          item.users = e.target.value;
          return item;
        })
      } else {
        setSearch(search => {
          const item = { ...search };
          item.userId = e.target.value.userId;
          item.userTerm = e.target.value.userTerm;
          item.users = e.target.value;
          return item;
        })
      }
    }
  }

  // 조회 이벤트
  const searchEvt = () => {
    // 월별일 경우 시작일은 1일 마지막일은 마지막 날짜로 한다.
    if (selectedValue === "MM") {
      // search.startDtm = search.startDtm;
      // 시작 날짜 설정
      const startDate = search.startDtm;
      const startYear = kendo.toString(startDate, "yyyy");
      const startMonth = kendo.toString(startDate, "MM") - 1;
      const startDay = new Date(startYear, startMonth, 1);
      search.startDtm = startDay;
      // 마지막 날짜 설정
      const endDate = search.endDtm;
      const endYear = kendo.toString(endDate, "yyyy");
      const endMonth = kendo.toString(endDate, "MM");
      const lastDay = new Date(endYear, endMonth, 0);
      search.endDtm = lastDay;
    }
    // 페이징
    page.skip = 0;
    page.take = 20;

    // validaiotn
    // if( search.dongCode === "" || search.dongCode === null ){
    //   kendo.alert("읍면동을 선택 해주세요.");
    //   return;
    // }
    if (search.userId === "" || search.userId === null) {
      kendo.alert("대상자를 선택 해주세요.");
      return;
    }
    getDataSourceEvt();
  };

  const [data, setData] = useState(dataSource.userList.slice());
  const filterData = (filter) => {
    const data = dataSource.userList.slice();
    return filterBy(data, filter);
  };
  const filterChange = (event) => {
    setData(filterData(event.filter));
  };

  useEffect(() => {
    search.users = locationState ? { userTerm: locationState.elderTerm, userId: locationState.elderId } : { userTerm: "대상자 선택", userId: "" };
    search.userId = locationState ? locationState.elderId : "";
    search.userTerm = locationState ? locationState.elderTerm : "";
    
    search.startDtm = locationState ? new Date(locationState.startDtm) : new Date();
    search.endDtm = locationState ? new Date(locationState.endDtm) : new Date();
    search.radio = locationState ? locationState.radio : "HH";
    setSelectedValue(locationState ? locationState.radio : "HH");
    if (locationState) searchEvt();
    // getUserList();
  }, [locationState]);


  useEffect(() => {
    getDataList();
  }, []);

  return (
    <div className={styles.elderLogSearch}>
      <span className="searchSubTitleA">시군구</span>
      <DropDownList
        className="elderLogSearchDropdown"
        id="rgn"
        name="rgn"
        data={dataSource.rgnList}
        disabled={!isDeveloper() ? true : false}
        // className={styles.allStatusSearchDropdown}
        value={search.rgns}
        textField="rgnTermSimple"
        dataItemKey="rgnCode"
        defaultItem={defualtValRgn}
        onChange={changeDropEvent}
      />
      <span className="searchSubTitleA">읍면동</span>
      <DropDownList
        className="elderLogSearchDropdown"
        id="dong"
        name="dong"
        data={dataSource.dongList}
        disabled={!isAdmin() ? true : !search.rgnCode ? true : false}
        // className={styles.allStatusSearchDropdown}
        value={search.dongs}
        textField="dongTermSimple"
        dataItemKey="dongCode"
        defaultItem={defualtValDong}
        onChange={changeDropEvent}
      />
      <span className="searchSubTitleA">대상자</span>
      <DropDownList
        className="elderLogSearchDropdown"
        id="user"
        name="user"
        data={data}
        // className={styles.allStatusSearchDropdown}
        value={search.users}
        textField="userTerm"
        dataItemKey="userId"
        defaultItem={defaultValUser}
        onChange={changeDropEvent}
        filterable
        onFilterChange={filterChange}
      />
      {/* <span className="searchSubTitleB"></span>
      <span className="radioForm">
        <RadioButton name="cc" value="HH" label="" className="radioBtn" checked={selectedValue === "HH"} onChange={radioChange} />
        <label>
          <span></span>시간별
        </label>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <RadioButton name="cc" value="DD" label="" className="radioBtn" checked={selectedValue === "DD"} onChange={radioChange} />
        <label>
          <span></span>일별
        </label>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <RadioButton name="cc" value="MM" label="" className="radioBtn" checked={selectedValue === "MM"} onChange={radioChange} />
        <label>
          <span></span>월별
        </label>
        &nbsp;&nbsp;&nbsp;&nbsp;
      </span> */}
      <span className="searchSubTitleB">조회기간</span>
      <DatePickerKo
        className="elderLogDatePicker"
        id="start"
        name="start"
        defaultValue={today}
        format={selectedValue === "MM" ? "yyyy-MM" : "yyyy-MM-dd"}
        setDtm={v => {
          search.startDtm = v;
          search.endDtm = v;
          setEndMin(v);
        }}
        max={startMax}
        value={search.startDtm}
      />
      {/* <span className="textColorGr"> ~ </span>
      <DatePickerKo
        id="end"
        name="end"
        className="datePicker"
        defaultValue={today}
        format={selectedValue === "MM" ? "yyyy-MM" : "yyyy-MM-dd"}
        setDtm={v => {
          search.endDtm = v;
          setStartMax(v);
        }}
        min={endMin}
        max={today}
      /> */}
      <span className="searchSubTitleC">
        <Button className={styles.searchButton} icon="search" onClick={searchEvt}>조회</Button>
      </span>
      {/* 임시 */}
      {/* <DropDownList
        style={{marginLeft: '40px'}}
        className="test"
        data={testList}
        onChange={changeList}
        defaultItem={"디바이스 제어 명령"}
      />
      <span className="searchSubTitleC"
        style={{marginLeft: '0px'}}>
        <Button style={{border: '1px solid red'}} className={styles.searchButton} onClick={changeStatus}>실행</Button>
      </span> */}
    </div>
    // <div className="uk-grid">
    //   <div className="uk-width-medium-1-1">
    //     <div className="md-card TBgA">
    //       <div className="md-card-content small-padding">
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default ElderLogSearch;
